import { logger } from '../../../../../utils/common/logger'
import { DOMUtils } from '../../../../../utils/dom'
import { IdentityScreen } from '../../../enums'
import { LoginService } from '../services/login-service'
import { ILRWidgetOptions, LoginRadiusWidget, LRWidgetType } from './base'

export interface IWindow extends Window {
    social_lrobj: any
}

export interface ISuccessResponse {
    Profile: any,
    Data: any,
    access_token: string,
    jwttoken: string
}

declare let window: IWindow

export class SocialLoginWidget extends LoginRadiusWidget {
    private static showNewsletterOptIn: boolean

    private socialLogintemplate: string

    constructor(container: string, lrObject: any, template: string, showNewsletterOptIn: boolean) {
        super()
        this.widgetType = LRWidgetType.SOCIAL_LOGIN
        this.lrObject = lrObject
        this.container = container
        this.socialLogintemplate = template
        SocialLoginWidget.showNewsletterOptIn = showNewsletterOptIn

        logger('info', 'login widget created')
    }

    public initForm() {
        if (document.querySelector(`#${this.container}`)) {
            const widgetOptions = {
                container: this.container,
                onError: this.onError,
                onSuccess: this.onSuccess,
                templateName: this.socialLogintemplate
            } as ILRWidgetOptions

            this.lrObject.customInterface('.social-login-interface', widgetOptions)

            this.lrObject.init(this.widgetType, widgetOptions)
            window.social_lrobj = this.lrObject

            // show complete your profile form
            this.lrObject.$hooks.register('socialLoginFormRender', () => {
                // remove access token from redirect_url key in session storage
                const redirectUrl = LoginService.getRedirectUrl(location.href)
                if (redirectUrl && redirectUrl.includes('lr-token')) {
                    LoginService.setRedirectUrl(location.href)
                }

                // remove access token from url
                LoginService.removeAccessTokenFromUrl()
                DOMUtils.addClass(document.body, IdentityScreen.SOCIAL_FORM)

                // scroll to content blocker
                LoginService.scrollToContentBlocker()
            })
        }
    }

    protected async onSuccess(response: ISuccessResponse) {
        logger('info', 'social-login-widget: Successfully logged in: ', response)
        LoginService.clearErrors()
        // force to remove lr-token from url
        LoginService.removeAccessTokenFromUrl()
        await LoginService.handleLoginSuccess(response, true, SocialLoginWidget.showNewsletterOptIn)
    }

    protected onError(errors: any) {
        logger('error', 'social-login-widget: ', errors)
        LoginService.clearErrors()
        LoginService.showErrors(errors)
        // force to remove lr-token from url
        history.replaceState(history.state, '', DOMUtils.removeFromUrl('lr-token', location.href))
        LoginService.sendSubmissionErrorAnalytics(errors, 'social-login')
    }
}
